// extracted by mini-css-extract-plugin
export var link = "sidebarPost-module--link--3Wrhz";
export var taxomonies = "sidebarPost-module--taxomonies--361Mo";
export var titleLink = "sidebarPost-module--titleLink--3qQsH";
export var post = "sidebarPost-module--post--1QL2o";
export var date = "sidebarPost-module--date--1Izxs";
export var anchorStyles = "sidebarPost-module--anchorStyles--2CZSY";